module.exports = __webpack_public_path__ + "static/media/pain-overview-large@3x.651301d6.png";